import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChatContainer } from '@/components/chat/ChatContainer';
import { JobData } from '@/types/chat';
import { AppLayout } from '@/components/AppLayout';

export default function ChatJobPage() {
  const navigate = useNavigate();
  const { sessionId } = useParams<{ sessionId?: string }>();
  const location = useLocation();

  // Receive initialJobData from form → chat mode switch
  const initialJobData = (location.state as { initialJobData?: JobData })?.initialJobData;

  // Handle chat → form mode switch
  const handleSwitchToForm = (jobData: JobData, chatSessionId: string | null) => {
    navigate('/jobs/new', { state: { jobData, chatSessionId } });
  };

  return (
    <AppLayout
      actions={
        <Button variant="outline" onClick={() => navigate('/jobs')}>
          Voltar para Vagas
        </Button>
      }
    >
      <div className="flex-1 overflow-hidden" style={{ height: 'calc(100vh - 8rem)' }}>
        <ChatContainer
          sessionId={sessionId}
          initialJobData={initialJobData}
          onSwitchToForm={handleSwitchToForm}
        />
      </div>
    </AppLayout>
  );
}
